import { ImageOff } from 'lucide-react';
import { useState } from 'react';

/** A thumbnail that falls back to a neutral icon instead of the browser's broken-image glyph. */
export function PreviewImage({ src }: { src: string }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <ImageOff className="text-muted-foreground h-5 w-5" aria-hidden="true" />;
  }
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      className="h-full w-full object-contain"
      onError={() => {
        setFailed(true);
      }}
    />
  );
}
